<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productGroup.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('productGroup.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="d-flex">
            <ts-input
              v-model="search"
              v-tooltip="$t('productGroup.search')"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table 
        :columns="columns" 
        :records="resources" 
        :loading="loading"
        :expandable="true"
      >
        <template v-slot="{ record }">
          <td class="ts-font-khmer" >{{ record.pro_group_name_kh }}</td>
          <td>{{ record.pro_group_name_en }}</td>
          <td>{{ record.category.category_name_en }}</td>
          <td>
            <i :class="record.icon" class="fa-2x"></i>
          </td>
          <td class="text-center ts-space-x-3 ts-whitespace-no-wrap">
            <a
              href="#"
              v-tooltip="$t('productGroup.addPrinter')"
              class="text-primary"
              @click.prevent="addPrinter(record)"
            >
              <i class="fas fa-plus"></i>
            </a>
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <a href="#" :disabled="record._deleting">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </td>
        </template>
          <div slot="expand" slot-scope="prop">
            <table class="ts-w-1/2 ts-mx-auto">
              <thead>
                <tr>
                    <th>{{ $t('productGroup.printer') }}</th>
                    <th>{{ $t('productGroup.ipAddress') }}</th>
                    <th>{{ $t('productGroup.port') }}</th>
                    <th>{{ $t('productGroup.type') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(k, index) in prop.record.kot_printers"
                  :key="index"
                >
                  <td>{{ k.printer_kot }}</td>
                  <td>{{ k.printer_ip_adress }}</td>
                  <td>{{ k.port }}</td>
                  <td>{{ k.input_type }}</td>
                </tr>
              </tbody>
            </table>
          </div>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('productGroup.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
				width="400px"
      >
        <from-action
          @cancel="clearEdit"
          @fetchData="fetchData"
        />
      </a-modal>
      <a-modal
        v-if="showFormAddPrinter"
        v-model="showFormAddPrinter"
        :title="$t('productGroup.addPrinter')"
        centered
        :zIndex="1020"
        :footer="null"
        @cancel="onCancel"
				width="400px"
      >
        <FromAddPrinter 
          v-model="model"
          @fetchData="fetchData"
          @cancel="onCancel"
        />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'
import FromAddPrinter from './form-add-printer'

export default {
  name: 'groupIndex',
  components: {
    FromAction,
    FromAddPrinter
  },
  data() {
    return {
      loading: false,
      showForm: false,
      showFormAddPrinter: false,
      model: {
        pro_group_id: null,
        printer_kot: null,
        printer_ip_address: null,
        port: null,
        input_type: 'NETWORK'
      }
    }
  },
  computed: {
    ...mapState('product/group', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.product.group.search
      },
      set(newValue) {
        this.$store.commit('product/group/SET_SEARCH', newValue)
        this.$store.commit('product/group/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('productGroup.nameKh') },
        { name: this.$t('productGroup.nameEn') },
        { name: this.$t('productGroup.category') },
        { name: this.$t('productGroup.icon') },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('product/group/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('product/group/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit(){
       this.$store.commit('product/group/SET_EDIT_DATA', {})
      this.showForm = false
		},
		deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('product/group/destroy', record.pro_group_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    addPrinter(record){
      this.showFormAddPrinter = true
      this.model.pro_group_id = record.pro_group_id
      if(record.kot_printers.length > 0){
        this.model.printer_kot = record.kot_printers[0].printer_kot
        this.model.printer_ip_address = record.kot_printers[0].printer_ip_adress
        this.model.port = record.kot_printers[0].port
        this.model.input_type = record.kot_printers[0].input_type
      }
    },
    onCancel(){
      this.showFormAddPrinter = false
      this.model.pro_group_id = null
      this.model.printer_kot = null
      this.model.printer_ip_address = null
      this.model.port = null
      this.model.input_type = 'NETWORK'
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('product/group/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
